import {ChangeEvent, useCallback, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {pToast} from '../../common/container/PToast';

export default function useInquiryFile() {
  const {t} = useTranslation();

  const fileRef = useRef<HTMLInputElement>(null);
  const [fileList, setFileList] = useState<File[]>();

  const onChangeFile = (e: ChangeEvent<HTMLInputElement>) => {
    const el = e.target;
    const leftFileList = fileList || [];

    if (el.files) {
      const newFileList = [...leftFileList, ...el.files];

      if (newFileList.length > 5) {
        pToast('파일은 최대 5개까지 첨부 가능합니다.');
        return;
      }

      const sumOfSize = newFileList.reduce(
        (accSize, file) => accSize + file.size,
        0
      );

      if (sumOfSize > MB_10) {
        pToast('파일은 10MB까지 첨부 가능합니다.');
        return;
      }

      if (newFileList.length) {
        setFileList(newFileList);
        pToast(t('more_customer_inquiry_file_attached_toast'));
      }
    }
  };

  const initFileList = useCallback(() => {
    if (fileRef.current) {
      fileRef.current.value = '';
    }
  }, []);

  return {
    fileRef,
    fileList,
    setFileList,
    onChangeFile,
    initFileList,
  };
}

const MB_10 = 10 * 1024 * 1024;
